const STORAGE_KEY = 'bes_customer_portal_session_v1';
const SHOULD_PERSIST = process.env.NODE_ENV === 'test';

let currentSession = null;
const listeners = new Set();

function notify() {
  listeners.forEach((listener) => {
    try {
      listener(currentSession);
    } catch (_error) {
      // Ignore listener failures to keep store updates flowing.
    }
  });
}

function safeParse(raw) {
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch (_error) {
    return null;
  }
}

function loadSessionFromStorage() {
  if (!SHOULD_PERSIST || typeof window === 'undefined') return null;
  return safeParse(window.sessionStorage.getItem(STORAGE_KEY));
}

function persistSession(session) {
  if (typeof window === 'undefined') return;
  if (!session) {
    window.sessionStorage.removeItem(STORAGE_KEY);
    return;
  }
  if (!SHOULD_PERSIST) {
    return;
  }
  window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(session));
}

currentSession = loadSessionFromStorage();

export function getCustomerPortalSession() {
  return currentSession;
}

export function setCustomerPortalSession(nextSession) {
  currentSession = nextSession || null;
  persistSession(currentSession);
  notify();
}

export function clearCustomerPortalSession() {
  setCustomerPortalSession(null);
}

export function subscribeCustomerPortalSession(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
